<template>
  <div class="p-achievements">
    <!--头部-->
    <div class="title kf-animate kf-animate-img">
      <div class="title_text">
        <p>学生成果</p>
      </div>
    </div>
    <!--内容-->
    <div class="g-box">
      <router-link
        :to="'/article_details/' + item.id"
        class="box1"
        v-for="(item, index) in list"
        :key="index"
        :style="{ backgroundImage: 'url(' + item.image + ')' }"
      >
      </router-link>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";
export default {
  mixins: [page_mx],
  data() {
    return {};
  },
  methods: {
    init() {
      this.params = this.$route.params;
      this.getAjax();
    },
    getAjax() {
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 80px;
  width: 100%;
  height: 280px;
  background: url(~@/assets/img/case/title1.png) no-repeat center;
  background-size: cover;
}
.title_text {
  width: 360px;
  height: 84px;
  font-size: 60px;
  font-weight: 200;
  color: #ffffff;
  line-height: 84px;
  text-align-last: justify;
  text-align: justify;
}
.box1 {
  display: flex;
  width: 1100px;
  height: 340px;
  border-radius: 2px;
  margin-bottom: 60px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.box1:hover {
  box-shadow: 0px 0px 20px 0px rgba(168, 170, 184, 0.2);
}

.g-box {
  margin-bottom: 120px;
}
</style>
